<template>
<div>
  <div id="top" class="clearfix">
    <div class="top_title">
      <h1>futurelabo</h1>
      <span class="title">-未来を創る場-</span>
    </div>
  </div>
  <div id="about" class="clearfix section">
  <div class="inner-section">
    <div class="title clearfix element js-animation">
      <h2>futurelaboとは</h2>
    </div>
    <div class="about_left element js-animation">
      <h3>「未来 -future-」を<br>「創る場 -labo-」<br>という意味の会社名です</h3>
    </div>
    <div class="about_right element js-animation">
      <p class="about_txt">株式会社futurelabo（フューチャーラボ）は「自分、仲間、社会の未来を創る」を理念に設立されました。<br>
      「仲間と成長し挑戦する事で、社会によりよい影響を与える「場」を創る」<br>
      をミッションに学生や若手に学ぶ場を提供し、多くのよりよいサービスを社会に創造していきます。</p>
    </div>
     <div class="career_contact clearfix">
          <router-link tag="li" to="/contact"><a class="career_contact_btn">&gt;&nbsp;お問い合わせをする</a></router-link>
        </div>
  </div>
  </div>
  <div id="service" class="clearfix section">
  <div class="inner-section">
    <div class="title clearfix element js-animation">
      <h2>サービス</h2>
    </div>
    <div class="service_content clearfix">
      <div class = "internshipguide clearfix element js-animation">
        <div class="internImg">
          <img src="../assets/img/intern_logo.png" alt="インターンシップガイドロゴ" class="interncontImg">
          <a class="color_button" href="https://internshipguide.jp/" target="_blank">&gt;&nbsp;詳しく見る</a>
        </div>
        <div class="internTxt">
          <p>「インターンシップを探すなら、インターンシップガイド！」<br>
        日本で唯一の大学生のインターンシップの総合サイトです。約3人に1人が旧帝大、早慶レベルの学生で成長意欲の高い学生が登録しており、大企業からスタートアップ企業まで１０００社以上の企業様にご利用いただいております。</p>
        </div>
      </div>
      <div class="internshipguide_detail clearfix  element js-animation">
        <div class="internshipguide_for">
          <ul class="internshipguide_for_content clearfix">
            <ul class="internshipguide_for_content_svg">
              <li class="internshipguide_for_svg"><img src="../assets/svg/forCompany.svg" class="smallSvg"></li>
            </ul>
            <ul class ="internshipguide_for_txt_content">
              <li class="internshipguide_for_txt"><h5>企業の皆様へ</h5></li>
              <li class="internshipguide_for_txt"><p>優秀な学生が集うインターンシップガイドに、無料で掲載が可能。<br>採用費用も発生いたしません！</p></li>
              <li class="internshipguide_for_txt"><a class="color_button_small" href="https://internshipguide.jp/company/" target="_blank"> > 詳しく見る</a></li>
            </ul>
          </ul>
        </div>
        <div class="internshipguide_for">
          <ul class="internshipguide_for_content clearfix">
            <ul class="internshipguide_for_content_svg">
              <li class="internshipguide_for_svg"><img src="../assets/svg/forStudent.svg" class="smallSvg"></li>
            </ul>
            <ul class ="internshipguide_for_txt_content">
              <li class="internshipguide_for_txt"><h5>学生の皆様へ</h5></li>
              <li class="internshipguide_for_txt"><p>全国47都道府県、日本最大の掲載企業数！日本唯一のインターンシップ総合サイト。就活生も1,2年生も大学生なら今からインターン！</p></li>
              <li class="internshipguide_for_txt"><a class="color_button_small" href="https://internshipguide.jp/" target="_blank"> > 詳しく見る</a></li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div id ="client" class="clearfix section">
  <div class="inner-section">
    <div class="client_content element js-animation">
      <div class="title clearfix">
        <h2>主要取引先（社名五十音順、敬称略）</h2>
        <ul class="client_ul">
          <li>株式会社アイ・パッション</li>
          <li>株式会社アクセスヒューマネクスト</li>
          <li>株式会社学研教育みらい</li>
          <li>株式会社キャリアデザインセンター</li>
          <li>株式会社サポーターズ</li>
          <li>シンクトワイス株式会社</li>
          <li>株式会社ディスコ</li>
          <li>株式会社DYM</li>
          <li>株式会社日本マンパワー</li>
          <li>株式会社パソナ</li>
          <li>パーソルテンプスタッフ株式会社</li>
          <li>株式会社パフ</li>
          <li>株式会社ベネッセ i-キャリア</li>
          <li>株式会社ビズリーチ</li>
          <li>株式会社ホールハート</li>
          <li>株式会社マイナビ</li>
          <li>楽天株式会社</li>
          <li>株式会社リア・ステージ</li>
          <li>株式会社リアライブ</li>
          <li>株式会社リクルート</li>
          <li>他多数</li>
        </ul>
      </div>
    </div>
  </div>
  <div id ="career" class="clearfix section">
  <div>
  <div class="inner-section">
    <div class="career_content element js-animation">
      <div class="title clearfix">
        <h2>採用情報</h2>
      </div>
      <div class="career_page clearfix element js-animation">
        <div class="career_sort">
          <h3>中途採用</h3>
          <span>mid-career recruitment</span>
          <img src="../assets/img/career.jpg" class="careerImg">
          <p>少数精鋭のチームで一緒に社会を変革するサービスを創りませんか？全職種募集中！</p>
        </div>
        <div class="career_sort">
          <h3>アルバイト・パート</h3>
          <span>part time job</span>
          <img src="../assets/img/career2.jpg" class="careerImg">
          <p>アシスタント、コーポレートスタッフなど、お手伝いをお願いします！時短勤務歓迎！</p>
        </div>
        <div class="career_sort">
          <h3>学生インターン</h3>
          <span>school Intern</span>
          <img src="../assets/img/career3.jpg" class="careerImg">
          <p>営業、エンジニアなど既に多くの学生が現場で活躍してます！</p>
        </div>
      </div>
      <div class="career_contact clearfix">
        <router-link tag="li" to="/contact"><a class="career_contact_btn">&gt;&nbsp;お問い合わせをする</a></router-link>
      </div>
    </div>
  </div>
  </div>
  </div>
  <div id="company" class="clearfix section">
  <div class="inner-section">
    <div class="title clearfix element js-animation">
      <h2>会社概要</h2>
      <div class="table_list element js-animation">
        <dl class="bottom">
          <dd class="company_title">名称</dd>
          <dt class="company_cont">株式会社futurelabo</dt>
        </dl>
        <dl class="bottom">
          <dd class="company_title">代表取締役</dd>
          <dt class="company_cont">金山晴紀</dt>
        </dl>
        <dl class="bottom">
          <dd class="company_title">設立日</dd>
          <dt class="company_cont">2012年7月23日</dt>
        </dl>
        <dl class="bottom">
          <dd class="company_title">主な事業内容</dd>
          <dt class="company_cont">・インターンシップガイドの運営<br>
            ・大学生集客代行
          </dt>
        </dl>
        <dl class="no_bottom">
          <dd class="company_title">本社所在地</dd>
          <dt class="company_cont">〒150-0002 東京都渋谷区渋谷3-5-16渋谷三丁目スクエアビル2F
          </dt>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7710832472544!2d139.70462511495305!3d35.65801123885321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b5eac319ba7%3A0x7843073b29fb596a!2z44CSMTUwLTAwMDIg5p2x5Lqs6YO95riL6LC35Yy65riL6LC377yT5LiB55uu77yV4oiS77yUIOa4i-iwt-S4ieS4geebruOCueOCr-OCqOOCouODk-ODqw!5e0!3m2!1sja!2sjp!4v1596445399954!5m2!1sja!2sjp" width="100%" height="400" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </dl>
      </div>
    </div>
     <div class="career_contact clearfix">
          <router-link tag="li" to="/contact"><a class="career_contact_btn">&gt;&nbsp;お問い合わせをする</a></router-link>
        </div>
  </div>
  <!--
  <div id="news" class="clearfix section">
    <div class="title clearfix element js-animation">
      <h2>ニュース</h2>
      <div class="news_list element js-animation">
        <dl class="news_bottom">
          <dd class="news_date">2019.09.09</dd>
          <dt class="news_cont">コーポーレートページを新しくしました</dt>
        </dl>
      </div>
    </div>
  </div>
-->
 </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'index',
  layout: 'app',
  data () {
    return {
      msg: ''
    }
  }
  // watch: {
  //   '$route': function (n, o) {
  //     if (n.hash.match(/^#/)) {
  //       document.getElementById(n.hash.replace(/^#/, '')).scrollIntoView(true)
  //     }
  //     console.log('new, old', [n.hash, o.hash])
  //   }
  // },
  // mounted () {
  //   if (this.$route.hash.match(/^#/)) {
  //     document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView(true)
  //   }
  // }
}
</script>

<style>
  a{
    text-decoration: none;
    font-size: 0.8em;
  }
  h1{
    font-size:3.2em;
  }
  h2{
    font-size: 1.6em;
  }
  h2{
    font-size: 1.8em;
  }
  h4{
    font-size: 1.6em;
  }
  h5{
    font-size: 1.4em;
  }
  p{
    font-size: 0.9em;
    color: #4b4b4b;
  }
  ul,li{
    list-style: none;
  }
  h2,h3{
    color: #1f30aa;
  }
  .color_button,.color_button_small, .career_contact_btn{
    background-color: #1f30aa;
    border: 2px solid #1f30aa;
    color: #fff;
    line-height: 50px;
    margin-top: 20px;
  }
  .color_button:hover,
  .color_button_small:hover,
  .career_contact_btn:hover{
    background-color: #fff;
    border-color: #1f30aa;
    color: #1f30aa;
  }
  .contact_btn:hover a{
    color: #1f30aa;
  }
  .color_button{
    display: inline-block;
    width: 350px;
    height: 56px;
    text-align: center;
    text-decoration: none;
    line-height: 52px;
    outline: none;
    background-color: #1f30aa;
    border: 2px solid #1f30aa;
    color: #fff;
  }
  .career_contact_btn{
    display: inline-block;
    width: 96%;
    height: 56px;
    text-align: center;
    text-decoration: none;
    line-height: 52px;
    outline: none;
    font-size: 1.0em;
    font-weight: 600;
    margin-top: 20px;
  }
  .color_button::before,
  .color_button::after,
  .color_button_small::before,
  .color_button_small::after,
  .career_contact_btn::before,
  .career_contact_btn::after{
    position: absolute;
    z-index: -1;
    display: block;
    content: '';
  }
  .color_button,
  .color_button::before,
  .color_button::after,
  .color_button_small,
  .color_button_small::before,
  .color_button_small::after,
  .career_contact_btn::before,
  .career_contact_btn::after{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .color_button_small{
    display: inline-block;
    width: 150px;
    height: 35px;
    text-align: center;
    text-decoration: none;
    line-height: 30px;
    outline: none;
    border:solid 3px #1f30aa;
    background-color: #fff;
    color: #1f30aa;
  }
  .career_contact_btn{
    color: #fff;
    background-color: #1f30aa;
    border: 2px solid #1f30aa;
    display: inline-block;
    width: 100%;
    height: 56px;
    text-align: center;
    text-decoration: none;
    line-height: 54px;
    outline: none;
  }
  .career_contact_btn::before,
  .career_contact_btn::after{
    position: absolute;
    z-index: -1;
    display: block;
    content: '';
  }
  .career_contact_btn,
  .career_contact_btn::before,
  .career_contact_btn::after{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }
  .career_contact_btn:hover{
    background-color: #fff;
    border-color: #1f30aa;
    color: #1f30aa;
  }
  .smallSvg{
    width: 70%;
    display: block;
    margin: 60px 20px 40px 30px;
  }
  #top{
       margin: 0 auto;
    padding-top:500px;
      background-image: url(../assets/img/top_3.png);
  background-repeat: no-repeat;
  background-size: 100%;
  }
  .top_title span{
    font-size: 2.2em;
    font-weight: bold;
  }
  .top_title h1{
    font-weight: 900;
  }
  .top_title h1,
  .top_title span{
    color: #fff;
    background-color: #1f30aa;
    padding-right: 30px;
  }
  .top_title{
    margin-top: -14%;
    z-index: 99;
    position: relative;
    padding-left: 3%;
    background-color: #1f30aa;
    padding-top: 1%;
    padding-bottom: 1%;
    width: 380px;
    height: auto;
  }
  ul.navigation li.contact_btn a{
    color: #fff;
  }
  .serviceImg{
    width: 100%;
  }
  .top_image_sp{
    display: none;
  }
  .topImgSP{
    width: 100%;
  }
  .interncontImg{
    width: 360px;
    padding: 20px 0;
  }
  .internshipguide_for{
    border:#1f30aa 4px solid;
    width: 47%;
    margin: 0 10px;
    height: 250px;
    background-color: white;
  }

  .internshipguide_for_svg{
    width: 90%;
    height: 180px;
  }
  .internshipguide_for_txt{
    padding-bottom: 4px;
  }
  ul.internshipguide_for_content_svg{
    float: left;
    width: 40%;
  }
  .internshipguide_detail{
    margin: 80px 0;
    display: flex;
    justify-content: space-around;
  }
ul.internshipguide_for_txt_content{
  float: left;
  width: 56%;
  padding: 30px 0;
}
  .internshipguideImg_sp{
    display: none;
  }
  .section{
    padding: 100px 0 10px 0;
    margin: -50px 0 0 0;
  }

  .inner-section{
   margin:0 auto;
   width: 1080px;
  }

  #about h2{
    background: url(../assets/svg/about.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  .about_left{
    float: left;
    width: 45%;
    padding-top:40px;
    font-size: 1.6em;
    font-weight: 900;
  }
  .about_right{
    float: right;
    width: 45%;
    padding-top:40px;
  }
  #about p{
    line-height: 2.0em;
    letter-spacing: 0.1em;
  }
  p.about_txt{
    padding-bottom: 30px;
  }
  #service{
  background: url(../assets/img/servicebg.jpg) center center no-repeat;
  background-position: left top 200px;
  background-size: cover;
  }
  #service h2{
    background: url(../assets/svg/service.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  .internshipguide{
    display: flex;
    border:#1f30aa 6px solid;
    background-color: #fff;
  }

  .internImg{
    width: 50%;
    background-color: #fff;
    padding: 45px 3%;
    text-align: center;
  }
  .internTxt{
    width: 50%;
    background-color: #1f30aa;
    padding: 80px 3%;
  }
  .internTxt p{
    color: #fff;
    line-height: 2.2em;
  }
  .interncontImg{
    width: 360px;
    padding: 20px 0;
  }
  .service_content{
    margin-top: 90px;
  }
  .internshipguide_for{
    border:#1f30aa 4px solid;
    width: 47%;
  }
  ul.internshipguide_for_content li{
    display: inline-block;
  }
  .internshipguide_for_txt{
    padding-bottom: 4px;
  }
  #client h2{
    background: url(../assets/svg/company.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  .client_ul li {
     width: 330px;
    margin: 4px 10px;
    display: inline-block
  }

  #career{
  margin-top:-30px;
  }
  #career>div{
  background-color: #f8f8f8;
  padding-bottom:10px;
  }

  #career h2{
    background: url(../assets/svg/career.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  #career h3{
    color: #585858;
    font-size: 1.2em;
  }
  .career_content{
    width: 1080px;
    margin: 0 auto;
  }
  .career_page{
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
  .career_sort{
    margin-top: 50px;
    width: 30%;
    margin-right: 36px;
  }
  .careerImg{
    border-radius: 4px;
    margin: 10px 0;
    display: block;
    width: 100%;
  }
  .career_sort span{
    color: #1f30aa;
    font-size: 0.8em;
  }

  #company h2{
    background: url(../assets/svg/company.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  dl.bottom{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    text-align: left;
    border-bottom: 1px solid #ccc;
    padding: 24px 80px;
  }
  dl.no_bottom{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    text-align: left;
    padding: 30px 80px;
  }
  dd.news_date,
  dd.company_title{
    width: 30%;
    font-size: 1.0em;
    color: #4b4b4b;
  }
  dt.company_cont,
  dt.news_cont{
    width: 70%;
    font-size: 1.0em;
    color: #4b4b4b;
  }
  .table_list{
    padding: 40px 0;
  }
  iframe{
    margin-top: 60px;
  }
  #news h2{
    background: url(../assets/svg/news.svg) no-repeat left center;
    background-size: 60px;
    padding: 20px 0 20px 80px;
  }
  dl.news_bottom{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    text-align: left;
    border-bottom: 1px dotted #ccc;
    padding: 30px 40px;
    font-size:0.8em;
    color: #4b4b4b;
  }
  @media screen and (max-width:1080px) {
  .inner-section{
   margin:0 auto;
   width: 96%;
   padding: auto 2%;
  }
    #about,#company,#client,#service,.career_content,#news{
      width: 100%;
    }
  }

  @media screen and (max-width:867px) {
    .career_sort{
      width: 90%;
    }
    a{
      text-decoration: none;
      font-size: 0.9em;
    }
    h1{
      font-size:2.2em;
    }
    h2{
      font-size: 1.4em;
    }
    h3{
      font-size: 1.0em;
    }
    h4{
      font-size: 1.2em;
    }
    h5{
      font-size: 1.4em;
    }
    p{
      font-size: 0.9em;
      color: #4b4b4b;
    }
    #top{
       margin: 0 auto;
      background-image: url(../assets/img/top_sp.jpg);
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 65vw;
  }
    .top_title{
      float: none;
      padding-left: 10px;
      margin-top: calc(-80px - ((1vw - 3.2px) * 7.31));
      max-width: 280px;
      min-width: 190px;
      width: 40vw;
      height: auto;
    }
    .top_title h1{
      font-size:calc(25.3px + ((1vw - 3.2px) * 1.81));
    }
    .top_title span{
      font-size:calc(20.7px + ((1vw - 3.2px) * 1.48));
    }
    .about_right ,
    .about_left{
      float: none;
      width: 100%;
    }
    .about_right{
      padding-top: 20px;
    }
    .about_left{
      font-size:1.6em;
      padding: 5% 0;
    }
.section{
   padding: 100px 0 10px 0;
    margin: -50px 0 0 0;
  }
    #about h2{
      background-size: 50px;
      padding: 10px 0 10px 60px;
    }
    #about p{
      line-height: 2.2em;
      letter-spacing: 0.1em;
    }
    .internshipguideImg{
      display: none;
    }
    .internshipguideImg_sp{
      display: block;
    }

   .client_ul li {
   width: 42%;
    margin: 4px 10px;
    display: inline-block;
    vertical-align: top;
  }
    #service h2{
      background-size: 50px;
    }
    .serviceImgSP{
      width: 100%;
    }
    #service{
  background-image: url(../assets/img/servicebg_sp.jpg);
    }
    .interncontImg{
      width: 300px;
      margin: 0 auto;
      display: block;
    }
    .internImg{
      float: none;
      width: 90%;
    }
    .internTxt{
      float: none;
      width: 97%;
    }
    .internImg{
      padding:5% 2%;
    }
    .internTxt{
      padding:5% 2%;
      margin: 0;
    }
    .internTxt p {
      color: #fff;
      line-height: 1.8em;
    }
    .service_content{
      padding: 0 2%;
      width: 96%;
      margin: 40px 0;
    }
    .color_button{
      display: none;
    }
    .internshipguide{
      display: block;
      width: 96%;
      margin: 0 auto;
    }
    .internshipguide_for{
      width: 96%;
      margin: 0 auto 20px auto;
      height: auto;
    }
  .internshipguide_detail{
    display: block;
      width: 96%;
      margin: 60px auto 0;
  }
    ul.internshipguide_for_content_svg{
      float: none;
    }
    .smallSvg{
      width: 30%;
      margin: 20px auto 0 auto;
    }
    .internshipguide_for_svg{
      height: 140px;
      width: 100%;
    }
    ul.internshipguide_for_content_svg{
    width: 100%;
    }
    ul.internshipguide_for_txt_content{
      float: none;
      padding: 0;
      text-align: center;
      width: 100%;
    }
    .internshipguide_for_txt{
      padding-bottom: 10px;
    }
    .color_button_small{
      margin: 0;
      width: 250px;
    }
    #client h2{
      background-size: 50px;
    }
    .clientImg{
      display: none;
    }
    .clientSPImg{
      display: block;
      width: 100%;
    }
  .career_page{
    display: block;
    margin: 10px auto 20px;
  }
    #career h3{
      font-size: 1.2em;
    }
    #career h2{
      background-size: 50px;
    }
    #career{
      padding: 85px 0 20px 0;
      margin-top: -65px;
    }
    .career_sort{
      margin: 4% auto 8% auto;
      width: 96%;
      padding: 0 2%;
    }
    .career_contact_btn{
      margin: 5% 0 0 0;
      font-size: 1.0em;
    }
    dt.company_cont, dt.news_cont{
      font-size: 0.9em;
      width: 65%;
    }
    dd.news_date, dd.company_title{
      font-size: 0.9em;
      width: 35%;
    }
    .table_list{
      width: 96%;
    }
    dl.bottom,
    dl.no_bottom{
      padding: 20px;
    }
    dl.news_bottom{
    padding: 20px 10px;
  }
  #news{
    margin-top: -65px;
    padding-top: 65px;
    padding-bottom: 20px;
  }

  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue